import { message, adType } from '../config';
import AdFactory from '../lib/ad/AdFactory';
import Base from './Base';

/**
 * header
 */
export default class FullScreenAd extends Base {
    /**
     * constructor
     */
    constructor(options) {
        super({
            template: '.js-fullscreen-ad-template',
        }, options);
    }

    /**
     * initialize
     */
    initialize(options) {
        const { type } = options;

        this.render(type);
        this.cache({
            el: `.js-fullscreen.-${type}`,
            adEl: '.js-fullscreen__ad',
            waitEl: '.js-fullscreen__skip-wait',
            skipButtonEl: '.js-fullscreen__skip-click',
        });

        /** @property {string} type 広告タイプ */
        this.type = type;

        /** @property {number} timerId インステ広告スキップまでのカウントダウンタイマー */
        this.timerId = null;

        /** @property {class} admodule 広告モジュール */
        this.admodule = AdFactory.getInstance(
            this.config.adparam[type],
            adType[type],
            { target: this.$adEl },
        );

        /** @property {number} skipcnt 全画面広告を見て待った秒 */
        this.skipcnt = this.getSkipCountBy(type);

        this.binds();
    }

    /**
     * DOMに追加する
     */
    render(type) {
        const node = document.importNode(this.$template.content, true);
        node.firstElementChild.classList.add(`-${type}`);
        this.$template.parentNode.insertBefore(node, this.$template);
    }

    /**
     * イベントリスナー登録
     */
    binds() {
        this.$skipButtonEl
            .addEventListener('click', e => this.onSkipButtonClick(e));
    }

    /**
     * skipcntを取得
     *
     * @param {string} type adparamの種類
     */
    getSkipCountBy(type) {
        const { skipcnt, adparam } = this.config;

        return adparam[type].skipcnt || skipcnt;
    }

    /**
     * スキップボタンクリック時
     */
    onSkipButtonClick() {
        this.reset();

        this.observer.emit(message.fullscreenAdClickSkip, this.type);
    }

    /**
     * 初期状態に戻す
     */
    reset() {
        clearInterval(this.timerId);
        this.timerId = null;

        this.$waitEl.innerText = this.createSkipText(this.skipcnt);
        this.$waitEl.style.display = '';
        this.$skipButtonEl.style.display = '';
        this.$el.style.display = '';
        this.admodule.remove();
    }

    /**
     * 表示
     */
    show() {
        this.reset();
        this.$el.style.display = 'flex';
        this.$waitEl.style.display = 'block';

        this.admodule.load();

        this.prepareSkipButton();
    }

    /**
     * 非表示する
     */
    hide() {
        this.$el.style.display = 'none';
        this.$skipButtonEl.style.display = 'none';

        this.reset();
    }

    /**
     * スキップボタンの準備
     */
    prepareSkipButton() {
        let { skipcnt } = this;

        const tick = () => {
            skipcnt -= 1;

            if (skipcnt > 0) {
                this.$waitEl.innerText = this.createSkipText(skipcnt);
                return;
            }

            this.$waitEl.style.display = 'none';
            this.$skipButtonEl.style.display = 'block';
            clearInterval(this.timerId);
        };

        this.timerId = setInterval(tick, 1000);
    }

    /**
     * スキップ文言作成
     *
     * @param {integer} cnt スキップ残り秒数
     */
    createSkipText(second) {
        return `スキップまで${second}秒`;
    }

    /**
     * 広告が表示されているか
    */
    isVisible() {
        return this.$el.style.display === 'flex';
    }
}
